import {
  SET_DICTIONARY,
  SET_SERVICE_RECORD_SHEET,
  SET_PRINT,
  SET_PRINT_WITH_DETAIL,
  SET_IS_COPY_DATA,
  SET_SETTINGS
} from '@/vuex/service-record-sheet/type.mutation';
import serviceRecordSheetService from '@/services/service-record-sheet.service';

export const dictionaryType = {
  workingField: 'WorkingField',
  problemFound: 'ProblemFound',
  measures: 'Measures',
};

const state = {
  dictionaries: {},
  selectServiceRecordSheet: {},
  print: [],
  printWithDetail: false,
  isCopyData: false,
  settings: {},
};

/* eslint-disable no-param-reassign */
const mutations = {
  [SET_DICTIONARY](_state, payload) {
    _state.dictionaries = payload;
  },
  [SET_SERVICE_RECORD_SHEET](_state, payload) {
    _state.selectServiceRecordSheet = payload;
  },
  [SET_PRINT](_state, payload) {
    _state.print = payload;
  },
  [SET_PRINT_WITH_DETAIL](_state, payload) {
    _state.printWithDetail = payload;
  },
  [SET_IS_COPY_DATA](_state, payload) {
    _state.isCopyData = payload;
  },
  [SET_SETTINGS](_state, payload) {
    _state.settings = payload;
  }
};

const actions = {
  getDictionaryList({ commit }) {
    commit('setLoading', true, { root: true });
    return serviceRecordSheetService.getDictionaryList().then((response) => {
      commit(SET_DICTIONARY, response.data);
      commit('setLoading', false, { root: true });
    });
  },
  setSelectServiceRecordSheet({ commit }, payload) {
    commit(SET_SERVICE_RECORD_SHEET, payload);
  },
  setPrint({ commit }, payload) {
    commit(SET_PRINT, payload);
  },
  setPrintWithDetail({ commit }, payload) {
    commit(SET_PRINT_WITH_DETAIL, payload);
  },
  setIsCopyData({ commit }, payload) {
    commit(SET_IS_COPY_DATA, payload);
  },
  getServiceRecordSetting({ commit }) {
    commit('setLoading', true, { root: true });
    return serviceRecordSheetService.getServiceRecordSetting().then((response) => {
      commit(SET_SETTINGS, response.data);
      commit('setLoading', false, { root: true });
      return response.data;
    });
  }
};

const getters = {
  dictionaries: _state => _state.dictionaries,
  selectServiceRecordSheet: _state => _state.selectServiceRecordSheet,
  print: _state => _state.print,
  printWithDetail: _state => _state.printWithDetail,
  isCopyData: _state => _state.isCopyData,
  settings: _state => _state.settings,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
